import React from 'react';
import { canBeCleared, findOrderByItem } from '@/utils/resultsHelper';
import { orderByColumns } from '@/constants/fields';
import SortedColumn from './SortedColumn';
import UnsortedColumn from './UnsortedColumn';

const TableSortedColumn = ({
  name,
  onOrderByColumn,
  orderBy,
  orderByColumnFindName,
  sortable,
  singleSorting,
}) => {
  if (!sortable) {
    return (<UnsortedColumn columnId={name} />);
  }

  const columnName = orderByColumns[orderByColumnFindName] || orderByColumns[name] || name;
  const item = findOrderByItem(orderBy, columnName);
  const direction = item ? item.direction : null;

  return (
    <SortedColumn
      name={name}
      sorted={!!item}
      canBeCleared={canBeCleared(orderBy, singleSorting)}
      asc={direction === 'asc'}
      onClick={() => onOrderByColumn({ orderByColumn: columnName })}
    />
  );
};

export default TableSortedColumn;
